import { Component } from 'react';
import { API_ENDPOINT } from '../../../constants';
import ListBuilder from '../../../components/listBuilder';
import Isvg from 'react-inlinesvg';

import eyeIcon from "../../../assets/svg/eye.svg";
import addIcon from '../../../assets/svg/add-icon.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import refreshIcon from "../../../assets/svg/refresh-new.svg";
import noNotifications from '../../../assets/svg/no-notif.svg';
import paymentIcon from '../../../assets/svg/payment-icon.svg';
import linkSvg from '../../../assets/svg/users.svg';
import editIcon from '../../../assets/svg/edit.svg';
import conditionLinkIcon from '../../../assets/svg/conditional-link-icon.svg'
import lockSvg from '../../../assets/svg/lock.svg';
import cameraIcon from '../../../assets/svg/camera.svg';
import cancelIcon from '../../../assets/svg/close_case.svg'
import historyIcon from '../../../assets/svg/history.svg'

import ErrorModal from '../../../components/errorModal';
import InfoModal from '../../../components/infoModal';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';

import {
    updateParamsHelper,
    getParamsFromURL,
    parseJSON,
} from '../../../helpers/custom.helper';
import PreviewModal from '../../../components/previewModal';
import { formatDuration, formatIssueDate, formatPrescriptionDetails, getRefills, coverageClassMap, coverageStatusMap, aperakClassMap, aperakStatusMap, formatBoolean } from '../../../helpers/patientPrescriptionList_SWEDEN.helper';
import { Button, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import { calculateAgeFromSSN, getAgeFromDobOrSSN } from '../helper';
import CreatePayment from '../../payments/components/createPayment';
import Switch from '../../../components/forms/fields/switch';
import striptags from 'striptags';

class PrescriptionListTab_SWEDEN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: 'isOngoing',
                sortType: -1,
                filter: '',
            },
            loading: true,
            loadingAfter: true,
            initialList: [],
            prescriptionList: [],
            error: null,
            modified: 'Not modified'.translate(this.props.lang),
            swedenTicket: null,
            startReloading: false,
            renewModal: null,
            previewModal: null,
            cancelNote: '',
            manualAddForm: {
                medicationString: '',
                subheaderString: '',
                customDate: '',
                isOngoing: false,
                internalNote: '',
                internalOrdinationInstructions: '',
            },
        };
    }

    get = async () => {
        this.setState({
            loading: true,
            prescriptionList: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {
            const response = await fetch(
                `${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props._groupId || null,
                        patientId: this.props.patientId,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter
                    }),
                }
            );

            const data = await response.json();

            if (data.items) {
                const newState = {
                    loading: false,
                    prescriptionList: data.items,
                    total: data.total,
                };

                if (data.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching prescription list'.translate(this.props.lang),
            });
        }
        finally {
            this.setState({ loading: false });
        }
    };

    // trigger add
    addNewPrescriptionItem = async () => {
        if (this.state.loading) return;
        await this.swedenLogin();
    };

    // triger renew
    renewPrescriptionItem = async (id) => {
        await this.swedenLogin(id);
    };

    cancelPrescriptionItem = async (id, note) => {
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/${id}/cancel`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    isCancelled: true,
                    isCancelledNote: note || '',
                    groupId: this.props._groupId || null,
                    patientId: this.props.patientId,
                }),
            });

            if (!response.ok) this.setState({ loading: false, error: "Cancelling prescription failed".translate(this.props.lang) });

        } catch (err) {
            this.setState({ loading: false, error: err?.message || "Error cancelling prescription".translate(this.props.lang) });
        } finally {
            this.setState({ loading: false });
        }

        await this.get();
    }

    toggleIsOngoing = async (id, isOngoing) => {
        let updated = false;
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/${id}/toggle-isOngoing`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    isOngoing,
                    groupId: this.props._groupId || null,
                    patientId: this.props.patientId,
                }),
            });

            if (!response.ok) {
                this.setState({ loading: false, error: "Updating prescription failed".translate(this.props.lang) });
            } else {
                updated = true;
            }

        } catch (err) {
            this.setState({ loading: false, error: err?.message || "Error updating prescription".translate(this.props.lang) });
        } finally {
            this.setState({ loading: false });
        }

        if (updated) await this.get();
        return updated;
    }


    saveManualPrescription = async (form) => {
        let saved = false;
        this.setState({ loading: true, error: null });
        try {
            const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/manual-add`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    ...form,
                    groupId: this.props._groupId || null,
                    patientId: this.props.patientId,
                }),
            });
            if (!response.ok) {
                this.setState({ loading: false, error: "Adding prescription failed".translate(this.props.lang) });
            } else {
                saved = true;
            }
        } catch (err) {
            this.setState({ loading: false, error: err?.message || "Error adding prescription".translate(this.props.lang) });
        } finally {
            this.setState({ loading: false });
        }
        if (saved) await this.get();
        return saved;
    };

    savePrescriptionInPreviewModal = async (prescription) => {
        let updated = false;
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/${prescription?._id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    isOngoing: prescription?.isOngoing,
                    internalNote: prescription?.internalNote,
                    internalOrdinationInstructions: prescription?.internalOrdinationInstructions,
                    groupId: this.props._groupId || null,
                    patientId: this.props.patientId,
                }),
            });

            if (!response.ok) {
                this.setState({ loading: false, error: "Updating prescription failed" });
            } else {
                updated = true;
            }

        } catch (err) {
            this.setState({
                error: err?.message || "Error updating prescription"
            })
        } finally {
            this.setState({ loading: false });
        }

        return updated;
    }

    didSwedenLoginTicketExpire = async (swedenTicket) => {
        const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/login/check`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
            body: JSON.stringify({
                ticket: swedenTicket
            }),
        });

        const data = await response.json();

        if (data?.ticketExpired) {
            return true;
        }

        return false;
    };

    swedenLogin = async (id = null) => {
        this.setState({ loading: true, error: null });

        try {
            const ticketExpired = await this.didSwedenLoginTicketExpire(this.state.swedenTicket);

            if (ticketExpired || !this.state.swedenTicket) {
                const response = await fetch(`${API_ENDPOINT}/e-receipt/sweden/login`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    }
                });

                const data = await response.json();

                if (data?.ticket) {
                    this.setState({ loading: false, swedenTicket: data.ticket });
                    await this.addOrRenewPrescription(data.ticket, id);
                } else {
                    this.setState({ loading: false, error: data.error || "Alfa login failed" });
                }
            } else {
                await this.addOrRenewPrescription(this.state.swedenTicket, id);
            }

        } catch (err) {
            this.setState({ loading: false, error: err?.message || "Error logging into Alfa" });
        } finally {
            this.setState({ loading: false });
        }
    };

    // upsert
    addOrRenewPrescription = async (ticket, id) => {
        if (!ticket) return this.setState({ error: "No Alfa ticket available" });
        const { _groupId, patientId } = this.props;

        try {
            const urlRes = await fetch(`${API_ENDPOINT}/e-receipt/sweden/get-url`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                body: JSON.stringify({
                    ticket,
                    groupId: _groupId,
                    patientId,
                    id: id ? id : null
                }),
            });

            const urlData = await urlRes.json();

            if (!urlRes.ok || !urlData?.url) {
                return this.setState({
                    error: urlData?.error || "Failed to get Alfa session URL",
                });
            }

            const { url } = urlData;

            window.open(url, "_blank");

            this.setState({ setSyncingState: true });
        } catch (err) {
            this.setState({
                error: err?.message || "Error opening Alfa GUI",
            });
        }
    };

    watchReloading = async () => {
        if (this.reloading) return;
        this.reloading = true;

        try {
            const response = await fetch(
                `${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionList/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props._groupId || null,
                        patientId: this.props.patientId,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter
                    }),
                }
            );

            const data = await response.json();

            if (data.items) {
                const currentList = JSON.stringify(this.state.prescriptionList || []);
                const newList = JSON.stringify(data.items || []);

                if (currentList !== newList) {
                    this.get();
                    this.setState({ setSyncingState: false })
                }
            }

        } catch (err) {
            console.log("Reload check failed:", err?.message);
        }

        this.reloading = false;
    };

    startReloadWatcher = () => {
        this.reloadInterval = setInterval(() => {
            this.watchReloading();
        }, 15000);
    };

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.patient) {
                this.setState({ patient: this.props.patient });
            }
            if (this.props.prescriptionList) {
                this.setState({
                    loading: false,
                    prescriptionList: this.props.prescriptionList,
                });
            } else {
                this.get();
            }
        });

        this.startReloadWatcher();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading !== this.state.loading) {
            if (this.state.loading) {
                this.setState({ loadingAfter: true });
            } else {
                clearTimeout(this._loadingAfterTimeout);
                this._loadingAfterTimeout = setTimeout(() => {
                    this.setState({ loadingAfter: false });
                }, 100);
            }
        }

        if (
            prevProps.patientId !== this.props.patientId ||
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.setState({
                loading: true,
                prescriptionList: [],
                modified: 'Not modified'.translate(this.props.lang),
            });

            this.get();
        }

        if (
            prevState?.params?.sortField !== this.state?.params?.sortField
        ) {
            this.get();
        }
    }

    componentWillUnmount() {
        clearInterval(this.reloadInterval);
        clearTimeout(this._loadingAfterTimeout);
    }

    // always copy - paste these updateSort, updateParams, updateMultipleParams
    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    render() {
        let params = this.state.params;

        return (
            <Container fluid>
                <Row>
                    <Col lg="8">
                        <div className="patient-main-info">
                            <div className="patient-main-info-container">
                                <h6>{'Patient'.translate(this.props.lang)}</h6>
                                <div className="patient-main-right">
                                    {
                                        !this.state.patient?.phone && !this.state.patient?.email ?
                                            <div className='patient-no-notif'>
                                                <Isvg src={noNotifications} width={20} height={20} />
                                                <div>
                                                    {'Phone and email not registered'.translate(this.props.lang)}
                                                </div>
                                                <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.props.isConditionalLinksEnabled ?
                                            <button className="patient-button-2" onClick={() => {
                                                // this.setState({ conditionalLinkModal: JSON.parse(JSON.stringify(this.state.patient)) });
                                                this.props.openConditionalLinksModal();
                                            }}>
                                                <div className='button-elements-tooltip'>
                                                    <Isvg src={conditionLinkIcon} />
                                                    <div className='tooltip-text'>{'Custom patient content'.translate(this.props.lang)}</div>
                                                </div>

                                            </button>
                                            :
                                            null
                                    }
                                    {this.props.clinicGroupSettings?.twoFactorAuthentication ? <button className="patient-button-2" onClick={() => {
                                        const age = getAgeFromDobOrSSN(this.state.patient?.dateOfBirth, this.state.patient?.socialSecurityNumber);

                                        let isChild = false;

                                        if (typeof age === 'number' && this.props.AGE_LIMIT && age < this.props.AGE_LIMIT) isChild = true;

                                        this.props.openTwoFactorAuthenticationModal(isChild);
                                    }}>
                                        <div className='button-elements-tooltip'>
                                            <Isvg src={lockSvg} width={24} height={24} />
                                            <div className='tooltip-text'>{'Two factor authentication'.translate(this.props.lang)}</div>
                                        </div>

                                    </button> : null}
                                    <button className="patient-button-2" onClick={() => {
                                        // this.setState({
                                        // 	linkedAccoutns: true
                                        // })
                                        this.props.openLinkedAccountsModal();
                                    }}>
                                        <div className='button-elements-tooltip'>
                                            <Isvg src={linkSvg} />
                                            <div className='tooltip-text'>{'Linked accounts'.translate(this.props.lang)}</div>
                                        </div>

                                    </button>
                                </div>
                            </div>

                            <div>
                                <div>
                                    <p className="patient-name">{this.state.patient && this.state.patient.userLevel && this.state.patient.userData.name}	</p>
                                    <p className="patient-number">{this.state.patient && this.state.patient.socialSecurityNumber}	</p>
                                    <p className="patient-address">{this.state.patient && this.state.patient.userData && this.state.patient.userData.sex ? this.state.patient.userData.sex == 'male' ? 'Male'.translate(this.props.lang) : this.state.patient.userData.sex == 'Boy' ? 'Boy'.translate(this.props.lang) : this.state.patient.userData.sex == 'Girl' ? 'Girl'.translate(this.props.lang) : this.state.patient.userData.sex == 'female' ? 'Female'.translate(this.props.lang) : this.state.patient.userData.sex : ''}{this.state.patient && this.state.patient.userData && this.state.patient.userData.sex && this.state.patient.socialSecurityNumber ? ', ' : ''}{this.state.patient && this.state.patient.socialSecurityNumber ? (calculateAgeFromSSN(this.state.patient.socialSecurityNumber, this.props.country) + ' ' + (calculateAgeFromSSN(this.state.patient.socialSecurityNumber, this.props.country) == 1 ? 'year'.translate(this.props.lang) : 'years'.translate(this.props.lang))) : ''}</p>
                                    {
                                        this.props.patientInfoSettings?.isCustomIdEnabled ?
                                            <p className='patient-customId'>{this.props.patientInfoSettings?.customIdLabel ? this.props.patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}: {this.state.patient?.customId?.[this.props.selectedGroup] ?? 'N/A'}
                                                <div className='button-elements-tooltip' style={{ cursor: 'pointer' }} onClick={() => {
                                                    this.props.openCustomIdModal();
                                                }}>
                                                    <Isvg src={editIcon} width={20} height={20} />
                                                    <div className='tooltip-text'>{'Edit'.translate(this.props.lang)}</div>
                                                </div>
                                            </p>
                                            :
                                            null
                                    }
                                </div>
                                <div className={this.state.patient?.patientInfo?.[this.props.selectedGroup]?.infection || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.allergies || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField1 || this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField2 ? "patient-notes-exists" : "patient-notes"}>
                                    <button onClick={() => {
                                        // this.setState({
                                        // 	formInfo: {
                                        // 		infection: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].infection ? this.state.patient.patientInfo[this.props.selectedGroup].infection : '',
                                        // 		allergies: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].allergies ? this.state.patient.patientInfo[this.props.selectedGroup].allergies : '',
                                        // 		tsModified: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].tsModified ? this.state.patient.patientInfo[this.props.selectedGroup].tsModified : null,
                                        // 		modifiedByUsername: this.state.patient && this.state.patient.patientInfo && this.state.patient.patientInfo[this.props.selectedGroup] && this.state.patient.patientInfo[this.props.selectedGroup].modifiedByUsername ? this.state.patient.patientInfo[this.props.selectedGroup].modifiedByUsername : null,
                                        // 		customField1: this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField1 || '',
                                        // 		customField2: this.state.patient?.patientInfo?.[this.props.selectedGroup]?.customField2 || ''
                                        // 	}
                                        // })
                                        this.props.openImportantInfoModal()
                                    }}>
                                        <div className='button-elements-tooltip'>
                                            <Isvg src={infoIcon} />
                                            <div className='tooltip-text' style={{ minWidth: 180, bottom: 35 }}>{'Important information'.translate(this.props.lang)}</div>
                                        </div>
                                    </button>
                                </div>
                            </div>

                        </div>


                    </Col>
                    <Col lg="4" className="patient-payments-button-wrap">
                        {
                            this.props.EXTENDED_PAYMENT_MANAGEMENT && this.props.userPaymentPermissions?.createNewPayments ?
                                <div className='start-video-button-wrap'>
                                    <Button color="primary" onClick={() => {
                                        this.setState({ createPaymentModal: true })
                                        // this.props.createPaymentModalOpenHandler();
                                    }}>
                                        {/* <Isvg src={paymentIcon} /> */}
                                        {'Create payment'.translate(this.props.lang)}
                                    </Button>
                                    <div className='fake-svg-26' />
                                </div>
                                :
                                null
                        }
                        {/* {
								this.props.journalCuroflowEnable && this.props.uData?.journalCuroflow?.[this.props.selectedGroup]?.active ?
									<div className='start-video-button-wrap'>

										<Button color={this.props.isConsentActive ? "success" : "primary"} onClick={() => {
											if (!this.props.isConsentActive)
												this.props.toggleJournalRequestConsentForm();
										}}>
											{this.props.isConsentActive ? 'Consent granted'.translate(this.props.lang) : 'Request consent'.translate(this.props.lang)}
										</Button>
										<div className='fake-svg-26' />
									</div>
									: null
							} */}
                        <div className='start-video-button-wrap'>
                            <Button color="primary" onClick={() => {
                                if (!this.state.isJournalNoteActive) {
                                    this.props[0].history.push(`/my-data/clinic/payments?entries=10&sortField=timestamp&sortType=-1&filter=${this.state.patient.socialSecurityNumber}`)
                                } else {
                                    this.setState({
                                        isJournalNoteActiveChange: 'see payments'
                                    })
                                }
                            }}>
                                <Isvg src={paymentIcon} />
                                {'See payments'.translate(this.props.lang)}
                            </Button>
                            <div className='fake-svg-26' />
                        </div>

                        {
                            this.props._videoButtonEnabled && (this.props.chatConversation || this.props.chatId) && this.props.doctorCanStartVideoCall ?
                                <div className='start-video-button-wrap'>
                                    <Button onClick={() => {
                                        if (!this.state.isJournalNoteActive) {
                                            this.props.startVideoCallHandler();
                                        } else {
                                            this.setState({
                                                isJournalNoteActiveChange: 'start video call'
                                            })
                                        }
                                    }}>
                                        <Isvg src={cameraIcon} />
                                        {'Start video chat'.translate(this.props.lang)}
                                    </Button>
                                    <div className='button-elements-tooltip'>
                                        <Isvg src={infoIcon} width={26} height={26} />
                                        <div className='tooltip-text'>{`Note that if patient hasn't yet signed in and completed their account, the call might not get through. You can make sure the patient is signed in by sending a chat message. You can also activate the notification "Video call started" to send a video-link to the patient.`.translate(this.props.lang)}</div>
                                    </div>
                                </div> : null
                        }

                    </Col >
                </Row >

                <div className="panel" style={{ paddingTop: 0, marginLeft: 0, paddingLeft: 0 }}>
                    <div className='panel-header'>
                        <h5 className='component-header'>
                            {'Prescription list'.translate(this.props.lang)}
                        </h5>

                        <div className='button-elements-tooltip'>
                            <Isvg src={infoIcon} width={26} height={26} />
                            <div className='tooltip-text'>{`To cancel a prescription, use Status/History inside the Alfa eCare Recept interface.`.translate(this.props.lang)}</div>
                        </div>
                        <button
                            type="button"
                            className='btn add-button'
                            disabled={this.state.loadingAfter}
                            onClick={() => {
                                this.addNewPrescriptionItem();
                            }}
                        >
                            <Isvg src={addIcon} /> {'Add/Cancel prescription'.translate(this.props.lang)}
                        </button>

                        {/* <button
                            type="button"
                            className='btn remove-button'
                            style={{ marginLeft: '10px' }}
                            disabled={this.state.loadingAfter}
                            onClick={() => {
                                this.addNewPrescriptionItem();
                            }}
                        >
                            {'Cancel prescription'.translate(this.props.lang)}
                        </button> */}

                        <button
                            type="button"
                            className='btn manual-add-to-list-prescription-button'
                            style={{ marginLeft: '10px' }}
                            disabled={this.state.loadingAfter}
                            onClick={() => {
                                const now = new Date();
                                const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
                                    .toISOString()
                                    .slice(0, 16);
                                this.setState({
                                    manualAddForm: {
                                        ...this.state.manualAddForm,
                                        customDate: localISO
                                    }
                                });
                                this.setState({ manualAddToListModal: true })
                            }}
                        >
                            {'Add to list'.translate(this.props.lang)}
                        </button>


                    </div>

                    {this.state.setSyncingState && (
                        <h6 className="patientPrescriptionList-syncingDataText">
                            {'Please wait one minute until data is synced'.translate(this.props.lang)}
                            <span className="patientPrescriptionList-dots">
                                <span>.</span>
                                <span>.</span>
                                <span>.</span>
                            </span>
                        </h6>
                    )}

                    <ListBuilder
                        lang={this.props.lang}
                        loading={this.state.loading}
                        total={this.state.total}
                        hideEntries={false}
                        showNumeration={false}
                        // hideFilters={true}
                        customFilters={
                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <Label>{'Sort by:'.translate(this.props.lang)}</Label>
                                <Input
                                    type='select'
                                    value={this.state?.params?.sortField}
                                    className="schedule-container-input"
                                    onChange={(e) => {
                                        this.updateSort(e?.target?.value, this.state.params.sortType)
                                    }
                                    }>

                                    <option value={'isOngoing'}>{'Active'.translate(this.props.lang)}</option>
                                    <option value={'tsCreated'}>{'Date'.translate(this.props.lang)}</option>

                                </Input>
                            </div>
                        }
                        fields={[
                            {
                                type: 'text',
                                label: 'Ongoing'.translate(this.props.lang),
                                name: 'isOngoingDisplay',
                            },
                            {
                                type: 'text',
                                label: 'Medication'.translate(this.props.lang),
                                name: 'medicationDisplay'
                            },
                            {
                                type: 'text',
                                label: 'Date'.translate(this.props.lang),
                                name: 'dateDisplay'
                            },
                            {
                                type: 'text',
                                label: 'Prescriber'.translate(this.props.lang),
                                name: 'prescriberDisplay'
                            },
                            {
                                type: 'text',
                                label: 'Refills'.translate(this.props.lang),
                                name: 'refillsDisplay'
                            },
                            // {
                            //     type: 'text',
                            //     label: 'Beneficiary'.translate(this.props.lang),
                            //     name: 'coverageDisplay'
                            // },

                            {
                                type: 'text',
                                label: 'Aperak / Status'.translate(this.props.lang),
                                name: 'aperakDisplay'
                            },
                        ]}

                        items={this.state?.prescriptionList?.map((item) => {
                            const prescriptionItem = item?.prescription?.prescriptionSet?.prescriptionItems[0];
                            const prescriber = item?.prescription?.prescriber;

                            const refills = getRefills(prescriptionItem);
                            const duration = formatDuration(prescriptionItem);
                            const { formattedDate, formattedTime } = formatIssueDate(item?.isManuallyAdded === true ? item?.customDate?.tsCreatedLocal : item?.prescription?.prescriptionSet?.prescriptionSetIssueTime);
                            const { mainLine, detailsLine } = formatPrescriptionDetails(prescriptionItem);

                            return {
                                ...item,
                                isOngoingDisplay: (
                                    <div>
                                        <FormGroup>
                                            <Switch
                                                value={item?.isOngoing ? true : false}
                                                disabled={item?.isCancelled === true}
                                                onChange={async e => {
                                                    if (item?.isCancelled === true) return;
                                                    const isOngoing = e.target.checked;

                                                    await this.toggleIsOngoing(item?._id, isOngoing);
                                                }}
                                            />
                                        </FormGroup>
                                    </div>
                                ),
                                medicationDisplay: (
                                    <div>
                                        <div style={{ fontWeight: 600 }}>{item?.isManuallyAdded ? item?.medicationString : mainLine}</div>
                                        <div className="patientPrescriptionList-subtext">{item?.isManuallyAdded ? item?.subheaderString : detailsLine}</div>
                                        <div className="patientPrescriptionList-internalOrdinationInstructions-yellowText">{item?.internalOrdinationInstructions || ""}</div>
                                    </div>
                                ),
                                dateDisplay: (
                                    <div>
                                        {formattedDate && <div>{formattedDate}</div>}
                                        {formattedTime && <div className="patientPrescriptionList-subtext">{formattedTime}</div>}
                                    </div>
                                ),
                                prescriberDisplay: (
                                    <div>
                                        {prescriber?.username && <div>{prescriber.username}</div>}
                                        {prescriber?.title && <div className="patientPrescriptionList-subtext">{prescriber.title}</div>}
                                    </div>
                                ),
                                refillsDisplay: (
                                    <div>
                                        {!item?.isManuallyAdded && (
                                            <>
                                                <div>
                                                    {refills} <span>{'refills'.translate(this.props.lang)}</span>
                                                </div>
                                                {duration && (
                                                    <div className="patientPrescriptionList-subtext">
                                                        {duration}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                ),
                                coverageDisplay: (
                                    <div>
                                        <div className={`patientPrescriptionList-careCoverageType-${coverageClassMap[prescriptionItem?.careCoverageType]}`}>
                                            <span>{coverageStatusMap[prescriptionItem?.careCoverageType]?.translate(this.props.lang)}</span>
                                        </div>
                                    </div>
                                ),
                                aperakDisplay: (
                                    <div>
                                        {item?.isCancelled === true ? (
                                            <div className={`tabel-action-tooltip patientPrescriptionList-aperak-${aperakClassMap[99]}`}>
                                                {item?.isCancelledNote && (
                                                    <div className='chat-icons-tooltip'>
                                                        {item?.isCancelledNote || item?.aperak?.description}
                                                    </div>
                                                )}

                                                <span>• {aperakStatusMap[99]?.translate(this.props.lang)}</span>
                                            </div>
                                        ) : (
                                            <div className={`tabel-action-tooltip patientPrescriptionList-aperak-${aperakClassMap[item?.aperak?.messageStatus]}`}>

                                                {Number(item?.aperak?.messageStatus) !== 100 && (
                                                    <div className='chat-icons-tooltip'>
                                                        {item?.aperak?.description}
                                                    </div>
                                                )}

                                                <span>• {aperakStatusMap[item?.aperak?.messageStatus]?.translate(this.props.lang)}</span>
                                            </div>
                                        )}

                                    </div>
                                ),
                            };
                        })}

                        actions={[
                            {
                                component: (
                                    <div className='tabel-action-tooltip'>
                                        {' '}
                                        <Isvg style={{ height: 24, width: 24 }} src={refreshIcon} />{' '}
                                        <div className='chat-icons-tooltip'>
                                            {'Renew'.translate(this.props.lang)}
                                        </div>{' '}
                                    </div>
                                ),
                                onClick: (item) => {
                                    this.setState({ renewModal: item });
                                },
                                condition: (item) => item?.isCancelled !== true && item?.isManuallyAdded !== true
                                // condition: (item) => {
                                // const hasPermission = this.props?.uData?.journalCuroflow[this.props?.selectedGroup]?.permissions?.writePatientVitalLogs;
                                // return hasPermission && item && !item?.isDeleted;
                                // },
                            },
                            {
                                component: (
                                    <div className='tabel-action-tooltip'>
                                        {' '}
                                        <Isvg src={historyIcon} />{' '}
                                        <div className='chat-icons-tooltip'>
                                            {'View history'.translate(this.props.lang)}
                                        </div>{' '}
                                    </div>
                                ),
                                onClick: (item) => {
                                    this.setState({ historyModal: item });
                                },
                                condition: (item) => item?.history && item?.history?.length > 0
                            },
                            {
                                component: (
                                    <div className='tabel-action-tooltip'>
                                        {' '}
                                        <Isvg src={eyeIcon} />{' '}
                                        <div className='chat-icons-tooltip'>
                                            {'Preview'.translate(this.props.lang)}
                                        </div>{' '}
                                    </div>
                                ),
                                onClick: (item) => {
                                    this.setState({ previewModal: item });
                                },
                            },
                            {
                                component: (
                                    <div className="tabel-action-tooltip"> <Isvg src={cancelIcon} className="cancel-icon" />
                                        <div className="chat-icons-tooltip">
                                            {'Mark as cancelled'.translate(this.props.lang)}</div>
                                    </div>),
                                onClick: (item) => {
                                    this.setState({ cancelModal: item });
                                },
                                condition: (item) => item?.isCancelled !== true && item?.isManuallyAdded === true
                            },
                        ]}
                        rawItems={this.state.items}
                        params={params}
                        sortField={params.sortField}
                        sortType={params.sortType}
                        updateSort={this.updateSort}
                        updateParams={this.updateParams}
                        updateMultipleParams={this.updateMultipleParams}
                    ></ListBuilder>

                    {/* Manual add to list modal  */}
                    <PreviewModal
                        lang={this.props.lang}
                        isOpen={!!this.state?.manualAddToListModal}
                        toggle={() => this.setState({ manualAddToListModal: false, manualAddForm: { medicationString: '', subheaderString: '', date: '', isOngoing: false, internalNote: '', internalOrdinationInstructions: '' } })}
                        title={'Add new prescription'.translate(this.props.lang)}
                        beforeCloseButton={<Button
                            color="primary"
                            onClick={async () => {
                                const saved = await this.saveManualPrescription(this?.state?.manualAddForm);
                                if (saved) {
                                    this.setState({ manualAddToListModal: false, manualAddForm: { medicationString: '', subheaderString: '', date: '', isOngoing: false, internalNote: '', internalOrdinationInstructions: '' } });
                                }
                            }}
                        >{'Add'.translate(this.props.lang)}</Button>}
                    >
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder={'Medication'.translate(this.props.lang)}
                                value={this?.state?.manualAddForm?.medicationString}
                                onChange={(e) => {
                                    const value = e?.target?.value;
                                    this.setState(prev => ({ manualAddForm: { ...prev?.manualAddForm, medicationString: striptags(value) } }))
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder={'Medication "Subheader"'.translate(this.props.lang)}
                                value={this?.state?.manualAddForm?.subheaderString}
                                onChange={(e) => {
                                    const value = e?.target?.value;
                                    this.setState(prev => ({ manualAddForm: { ...prev?.manualAddForm, subheaderString: striptags(value) } }))
                                }}
                            />
                        </FormGroup>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                            <FormGroup style={{ flex: 1, marginBottom: 16 }}>
                                <Input
                                    type="datetime-local"
                                    value={this?.state?.manualAddForm?.customDate}
                                    onChange={(e) => {
                                        const value = e?.target?.value;
                                        this.setState(prev => ({ manualAddForm: { ...prev?.manualAddForm, customDate: value } }))
                                    }}
                                />
                            </FormGroup>

                            <FormGroup
                                className="patientPrescriptionList-date-and-ongoing-add-manual-modal"
                            >
                                <Label style={{ marginBottom: 0, marginTop: 2 }}>
                                    {'Ongoing'.translate(this.props.lang)}
                                </Label>

                                <Switch
                                    value={this?.state?.manualAddForm?.isOngoing}
                                    onChange={(e) => {
                                        const value = e?.target?.checked;
                                        this.setState(prev => ({
                                            manualAddForm: { ...prev?.manualAddForm, isOngoing: Boolean(value) }
                                        }))
                                    }}
                                />
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <Input
                                type="textarea"
                                placeholder={'Internal note'.translate(this.props.lang)}
                                value={this?.state?.manualAddForm?.internalNote}
                                style={{ height: 80 }}
                                onChange={(e) => {
                                    const value = e?.target?.value;
                                    this.setState(prev => ({ manualAddForm: { ...prev?.manualAddForm, internalNote: striptags(value) } }))
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                type="textarea"
                                placeholder={'Internal ordination information'.translate(this.props.lang)}
                                value={this?.state?.manualAddForm?.internalOrdinationInstructions}
                                style={{ height: 80 }}
                                onChange={(e) => {
                                    const value = e?.target?.value;
                                    this.setState(prev => ({ manualAddForm: { ...prev?.manualAddForm, internalOrdinationInstructions: striptags(value) } }))
                                }}
                            />
                        </FormGroup>
                        <p className="patientPrescriptionList-small-text-add-manual-modal">
                            {'Observe: Manually added prescription are only visible inside of Curoflow. They cannot be renewed with Alfa.'.translate(this.props.lang)}
                        </p>
                    </PreviewModal>

                    {/* History */}
                    <PreviewModal
                        className={'patientPrescriptionList-historyModal'}
                        lang={this.props.lang}
                        isOpen={!!this.state.historyModal}
                        toggle={() => this.setState({ historyModal: false })}
                        title={'Prescription History'.translate(this.props.lang)}
                    >
                        {[...(this.state.historyModal?.history || [])].reverse().map((item, index) => {
                            const fieldLabelMap = {
                                internalNote: 'Internal note'.translate(this.props.lang),
                                internalOrdinationInstructions: 'Internal ordination instructions'.translate(this.props.lang),
                                isCancelled: 'Is cancelled'.translate(this.props.lang),
                                isCancelledNote: 'Cancellation note'.translate(this.props.lang),
                                isOngoing: 'Ongoing'.translate(this.props.lang),
                            };

                            const typeLabel =
                                item.type === 'UPDATE' ? 'Prescription is updated'.translate(this.props.lang) :
                                    item.type === 'TOGGLE_IS_ONGOING' ? 'Prescription is toggled from table view'.translate(this.props.lang) :
                                        item.type === 'CANCEL' ? 'Prescription is cancelled'.translate(this.props.lang) :
                                            item.type === 'CREATE' ? 'Prescription is created manually'.translate(this.props.lang) :
                                                item.type;

                            const date = this.props.lang === 'en' ? item.tsCreatedDateEn : item.tsCreatedDateSv;
                            const doctor = [item.doctor?.title, item.doctor?.name].filter(Boolean).join(' ') || 'N/A';

                            return (
                                <div key={index} >
                                    <div className="patientPrescriptionList-historyModal-metadata-wrap">
                                        <div className="patientPrescriptionList-historyModal-metadata-date">{date}</div>
                                        <div className="patientPrescriptionList-historyModal-metadata-doctor">{doctor}</div>
                                        <div className="patientPrescriptionList-historyModal-metadata-typeLabel">{typeLabel}</div>
                                    </div>

                                    {item?.changes?.length > 0 && (
                                        <table className="patientPrescriptionList-historyModal-changes-table">
                                            <thead>
                                                <tr className="patientPrescriptionList-historyModal-changes-table-thead-tr">
                                                    <th className="patientPrescriptionList-historyModal-changes-table-thead-tr-th patientPrescriptionList-historyModal-changes-table-thead-tr-th-left"></th>
                                                    <th className="patientPrescriptionList-historyModal-changes-table-thead-tr-th patientPrescriptionList-historyModal-changes-table-thead-tr-th-right">{'Old value'.translate(this.props.lang)}</th>
                                                    <th className="patientPrescriptionList-historyModal-changes-table-thead-tr-th patientPrescriptionList-historyModal-changes-table-thead-tr-th-right">{'New value'.translate(this.props.lang)}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {item.changes.map((change, i) => {
                                                    const label = fieldLabelMap[change.field] || change.field;
                                                    const isBooleanField = ['isCancelled', 'isOngoing'].includes(change.field);
                                                    const oldVal = isBooleanField ? formatBoolean(change?.oldValue, this.props.lang) : (change?.oldValue ?? '-');
                                                    const newVal = isBooleanField ? formatBoolean(change?.newValue, this.props.lang) : (change?.newValue ?? '-');

                                                    return (
                                                        <tr key={i} className="patientPrescriptionList-historyModal-changes-table-tbody-tr">
                                                            <td className="patientPrescriptionList-historyModal-changes-table-tbody-tr-td">{label}:</td>
                                                            <td className="patientPrescriptionList-historyModal-changes-table-tbody-tr-td">{oldVal || '-'}</td>
                                                            <td className="patientPrescriptionList-historyModal-changes-table-tbody-tr-td">{newVal || '-'}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}

                                    {index !== this.state.historyModal.history.length - 1 && <hr className="patientPrescriptionList-historyModal-changes-hr" />}
                                </div>
                            );
                        })}
                    </PreviewModal>


                    {/* Preview */}
                    <PreviewModal
                        lang={this.props.lang}
                        isOpen={!!this.state.previewModal}
                        toggle={() => this.setState({ previewModal: false })}
                        title={'Preview Prescription'.translate(this.props.lang)}
                        beforeCloseButton={<Button type="button" onClick={async () => {
                            const dataToSubmit = {
                                internalNote: this.state.previewModal?.internalNote,
                                internalOrdinationInstructions: this.state.previewModal?.internalOrdinationInstructions,
                                isOngoing: this.state.previewModal?.isOngoing,
                                _id: this.state.previewModal?._id,
                                journalItemId: this.state.previewModal?.journalItemId
                            }
                            const updated = await this.savePrescriptionInPreviewModal(dataToSubmit)
                            if (updated) {
                                await this.get();
                                this.setState({ previewModal: false });
                            }
                        }

                        } >{'Save'.translate(this.props.lang)}</Button>}

                    >
                        {this.state.previewModal && (() => {
                            const modal = this.state?.previewModal;
                            const prescriber = modal.prescription?.prescriber;
                            const patient = modal.prescription?.patient;
                            const prescriptionItem = modal.prescription?.prescriptionSet?.prescriptionItems?.[0];
                            const medicalItem = modal?.medicalItem;
                            const aperak = modal?.aperak;
                            const refills = getRefills(prescriptionItem);
                            const duration = formatDuration(prescriptionItem);
                            const { formattedDate, formattedTime } = formatIssueDate(modal?.isManuallyAdded ? modal?.customDate?.tsCreatedLocal : modal.prescription?.prescriptionSet?.prescriptionSetIssueTime);

                            const IS_MANUALLY_ADDED = modal?.isManuallyAdded ? true : false;

                            return (
                                <div>
                                    {IS_MANUALLY_ADDED ? (
                                        <>
                                            <div><b>{'Doctor'.translate(this.props.lang)}:</b> {prescriber?.username}</div>
                                            <div><b>{'Title'.translate(this.props.lang)}:</b> {prescriber?.title}</div>
                                            <div><b>{'Workplace'.translate(this.props.lang)}:</b> {prescriber?.workplaceName}</div>

                                            <hr />

                                            <div><b>{'Patient'.translate(this.props.lang)}:</b> {patient?.firstGivenName} {patient?.familyName}</div>
                                            <div><b>{'PNR'.translate(this.props.lang)}:</b> {patient?.pnr}</div>
                                            <div><b>{'City'.translate(this.props.lang)}:</b> {patient?.city}</div>
                                            <div><b>{'Phone'.translate(this.props.lang)}:</b> {patient?.telecommunication}</div>

                                            <hr />

                                            <div><b>{'Medication'.translate(this.props.lang)}:</b> {modal?.medicationString}</div>
                                            <div><b>{'Subheader'.translate(this.props.lang)}:</b> {modal?.subheaderString}</div>

                                            <hr />

                                            <div><b>{'Ongoing'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Switch
                                                        disabled={this.state.previewModal?.isCancelled === true}
                                                        value={modal?.isOngoing ? true : false}
                                                        onChange={async e => {
                                                            if (this.state.previewModal?.isCancelled === true) return;
                                                            const isOngoing = e.target.checked;

                                                            // const updated = await this.toggleIsOngoing(modal?._id, isOngoing);
                                                            this.setState({ previewModal: { ...this.state.previewModal, isOngoing } })

                                                        }}
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div><b>{'Internal note'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Input type='textarea' value={modal?.internalNote || ""} style={{ height: 100 }}
                                                        onChange={(e) => {
                                                            const value = striptags(e.target.value);

                                                            this.setState(prevState => ({
                                                                previewModal: {
                                                                    ...prevState.previewModal,
                                                                    internalNote: value
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div><b>{'Internal note instructions'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Input type='textarea' value={modal?.internalOrdinationInstructions || ""} style={{ height: 100 }} onChange={(e) => {
                                                        const value = striptags(e.target.value);

                                                        this.setState(prevState => ({
                                                            previewModal: {
                                                                ...prevState.previewModal,
                                                                internalOrdinationInstructions: value
                                                            }
                                                        }));
                                                    }}
                                                    />
                                                </FormGroup>
                                            </div>


                                            <hr />

                                            <div><b>{'Status'.translate(this.props.lang)}:</b>
                                                {modal?.isCancelled === true ? (
                                                    <span className={`patientPrescriptionList-aperak-${aperakClassMap[99]}`}>
                                                        {aperakStatusMap[99]?.translate(this.props.lang)}
                                                    </span>
                                                ) : (
                                                    <span className={`patientPrescriptionList-aperak-${aperakClassMap[aperak?.messageStatus]}`}>
                                                        {aperakStatusMap[aperak?.messageStatus]?.translate(this.props.lang)}
                                                    </span>
                                                )}
                                            </div>

                                            <hr />

                                            <div><b>{'Date'.translate(this.props.lang)}:</b> {formattedDate}{formattedTime ? ` ${formattedTime}` : ''}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div><b>{'Doctor'.translate(this.props.lang)}:</b> {prescriber?.username}</div>
                                            <div><b>{'Title'.translate(this.props.lang)}:</b> {prescriber?.title}</div>
                                            <div><b>{'Workplace'.translate(this.props.lang)}:</b> {prescriber?.workplaceName}</div>

                                            <hr />

                                            <div><b>{'Patient'.translate(this.props.lang)}:</b> {patient?.firstGivenName} {patient?.familyName}</div>
                                            <div><b>{'PNR'.translate(this.props.lang)}:</b> {patient?.pnr}</div>
                                            <div><b>{'City'.translate(this.props.lang)}:</b> {patient?.city}</div>
                                            <div><b>{'Phone'.translate(this.props.lang)}:</b> {patient?.telecommunication}</div>

                                            <hr />

                                            <div><b>{'Medication'.translate(this.props.lang)}:</b> {prescriptionItem?.distributedTradeName}</div>
                                            <div><b>{'Strength'.translate(this.props.lang)}:</b> {prescriptionItem?.strengthText}</div>
                                            <div><b>{'Form'.translate(this.props.lang)}:</b> {prescriptionItem?.formText}</div>
                                            <div><b>{'Pack'.translate(this.props.lang)}:</b> {prescriptionItem?.packSizeText}</div>
                                            <div><b>{'Packages'.translate(this.props.lang)}:</b> {prescriptionItem?.numberOfPackages}</div>
                                            <div><b>{'Refills'.translate(this.props.lang)}:</b> {refills}{duration ? ` (${duration})` : ''}</div>
                                            <div><b>{'Unstructured Dosage Admin'.translate(this.props.lang)}:</b> {prescriptionItem?.unstructuredDosageAdmin ?? '-'}</div>
                                            <div><b>{'NPL Pack ID'.translate(this.props.lang)}:</b> {prescriptionItem?.nplPackId ?? '-'}</div>

                                            <hr />

                                            <div><b>{'Ongoing'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Switch
                                                        disabled={this.state.previewModal?.isCancelled === true}
                                                        value={modal?.isOngoing ? true : false}
                                                        onChange={async e => {
                                                            if (this.state.previewModal?.isCancelled === true) return;
                                                            const isOngoing = e.target.checked;

                                                            // const updated = await this.toggleIsOngoing(modal?._id, isOngoing);
                                                            this.setState({ previewModal: { ...this.state.previewModal, isOngoing } })

                                                        }}
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div><b>{'Internal note'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Input type='textarea' value={modal?.internalNote || ""} style={{ height: 100 }}
                                                        onChange={(e) => {
                                                            const value = striptags(e.target.value);

                                                            this.setState(prevState => ({
                                                                previewModal: {
                                                                    ...prevState.previewModal,
                                                                    internalNote: value
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                </FormGroup>
                                            </div>

                                            <div><b>{'Internal note instructions'.translate(this.props.lang)}:</b>
                                                <FormGroup>
                                                    <Input type='textarea' value={modal?.internalOrdinationInstructions || ""} style={{ height: 100 }} onChange={(e) => {
                                                        const value = striptags(e.target.value);

                                                        this.setState(prevState => ({
                                                            previewModal: {
                                                                ...prevState.previewModal,
                                                                internalOrdinationInstructions: value
                                                            }
                                                        }));
                                                    }}
                                                    />
                                                </FormGroup>
                                            </div>


                                            <hr />

                                            <div><b>{'Beneficiary'.translate(this.props.lang)}:</b>
                                                <span className={`patientPrescriptionList-careCoverageType-${coverageClassMap[medicalItem?.careCoverageType]}`}>
                                                    {coverageStatusMap[medicalItem?.careCoverageType]?.translate(this.props.lang)}
                                                </span>
                                            </div>

                                            <hr />

                                            <div><b>{'Status'.translate(this.props.lang)}:</b>
                                                {modal?.isCancelled === true ? (
                                                    <span className={`patientPrescriptionList-aperak-${aperakClassMap[99]}`}>
                                                        {aperakStatusMap[99]?.translate(this.props.lang)}
                                                    </span>
                                                ) : (
                                                    <span className={`patientPrescriptionList-aperak-${aperakClassMap[aperak?.messageStatus]}`}>
                                                        {aperakStatusMap[aperak?.messageStatus]?.translate(this.props.lang)}
                                                    </span>
                                                )}
                                            </div>

                                            <div><b>{'Description'.translate(this.props.lang)}:</b><br />
                                                {modal?.isCancelled === true && modal?.aperak?.messageStatus === "99" ? (
                                                    modal?.isCancelledNote
                                                ) : (
                                                    aperak?.description
                                                )}
                                            </div>

                                            <hr />

                                            <div><b>{'Date'.translate(this.props.lang)}:</b> {formattedDate}{formattedTime ? ` ${formattedTime}` : ''}</div>
                                        </>
                                    )}

                                </div>
                            );
                        })()}
                    </PreviewModal>

                    {/* Renew */}
                    {
                        this.state.renewModal ?
                            <InfoModal
                                isOpen={!!this.state.renewModal}
                                onClose={() => {
                                    this.setState({ renewModal: false })
                                }}
                                header={'Confirm Prescription Renew'.translate(this.props.lang)}
                                info={'Do you want to renew this prescription?'.translate(this.props.lang)}
                                buttons={[
                                    <Button color="primary" style={{ margin: 10 }}
                                        onClick={async () => {
                                            const id = this.state.renewModal?._id;
                                            await this.renewPrescriptionItem(id);
                                            this.setState({ renewModal: false })
                                        }}>{'Renew'.translate(this.props.lang)}</Button>,
                                    <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ renewModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>


                                ]}
                            /> : null
                    }

                    {/* Cancel */}
                    <PreviewModal
                        lang={this.props.lang}
                        isOpen={!!this.state.cancelModal}
                        toggle={() => this.setState({ cancelModal: false, cancelNote: '' })}
                        title={'Confirm Cancelling Prescription'.translate(this.props.lang)}
                        beforeCloseButton={
                            <Button type="button" className="button-blue"
                                onClick={async () => {
                                    const id = this.state?.cancelModal?._id;
                                    await this.cancelPrescriptionItem(id, this.state.cancelNote);
                                    this.setState({ cancelModal: false, cancelNote: '' });
                                }}>{'Confirm'.translate(this.props.lang)}</Button>
                        }
                    >
                        <p style={{ textAlign: 'center' }}>{'Are you sure you want to cancel this prescription? Cancellation note is optional.'.translate(this.props.lang)}</p>
                        <Input
                            type="textarea"
                            value={this.state.cancelNote}
                            onChange={(e) => this.setState({ cancelNote: e.target.value })}
                        />
                    </PreviewModal>

                    {/* Error */}
                    <ErrorModal
                        lang={this.props.lang}
                        isOpen={!!this.state.error}
                        toggle={() => this.setState({ error: null })}
                    >
                        {this.state.error}
                    </ErrorModal>

                    {/* Create payment modal */}
                    {
                        this.state.createPaymentModal ?
                            <CreatePayment
                                {...this.props}
                                hideSelectPatient={true}
                                patientId={this.props.patientId}
                                isOpen={!!this.state.createPaymentModal}
                                onClose={(callback) => {
                                    this.setState({ createPaymentModal: false }, () => {
                                        if (callback) callback();
                                    });
                                }}
                            />
                            :
                            null
                    }



                    <div className="patientPrescriptionList-info-bar">
                        <p>
                            <Isvg style={{ width: 24, height: 24 }} src={infoIcon} />
                            {' '}- {'To cancel a prescription, use'.translate(this.props.lang)}{' '}
                            <span>{'Status/History'.translate(this.props.lang)}</span>
                            {' '}{'inside the Alfa eCare Recept interface.'.translate(this.props.lang)}
                        </p>
                    </div>
                </div >
            </Container >
        );
    }

}

const selector = formValueSelector('modalForm');

export default connect(
    state => ({
        weight: selector(state, 'weight'),
        height: selector(state, 'height'),
    }),
    {
        changeField: (field, value) => change('modalForm', field, value),
    }
)(PrescriptionListTab_SWEDEN);

